var render = function render(){var _vm=this,_c=_vm._self._c;return _c('display-base',[_c('div',{staticClass:"display-led",style:({ '--size': _vm.size })},[_c('div',{staticClass:"display-led__content"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }